import {StripOptions} from '@/model/types';

const normalizedOptions = (options?: StripOptions) => {
  if (!options) return {};
  switch (typeof options) {
    case 'string':
      return {chars: options};
    case 'number':
      return options < 0 ? {last: -options} : {first: options};
    default:
      return options;
  }
};

const getCharsRegexp = (chars: string): string => {
  if (chars.includes('-')) {
    const normalizedChars = chars.replace(/-/g, '\\-');
    return `[${normalizedChars}]`;
  }
  return `[${chars}]`;
};

export const applyStripOptions = (value: string, options?: StripOptions) => {
  const {chars, first, last} = normalizedOptions(options);
  const replaced = chars ? value.replace(new RegExp(getCharsRegexp(chars), 'g'), '') : value;
  const trimmed = replaced.slice(first ?? 0, last ? -last : undefined);
  return trimmed;
};

export const isBlankOrEmpty = (value?: string | null): boolean => !value || value.trim().length === 0;

export const isNotBlankOrEmpty = (value?: string | null): boolean => !isBlankOrEmpty(value);

export const firstNotBlankOrDefault = (values: (string | undefined | null)[], defaultValue: string): string => {
  for (const value of values) {
    if (isNotBlankOrEmpty(value)) {
      return <string>value;
    }
  }
  return defaultValue;
};
